// start:ng42.barrel
import './cca-signup-dashboard.controller';
// end:ng42.barrel

